import { API } from '../../../core/http/api'
import { parseMessageFromAPI } from './serializers'

export const getLastThreads = async (page = 0, onlyVisibleLabels = false, filterMode) => {
  const res = await API.get(`threads?page=${page}&onlyVisibleLabels=${onlyVisibleLabels}&mode=${filterMode}`)

  if (res.status === 200) {
    if (!res.data) {
      return []
    }
    Object.values(res.data?.threads)?.map((thread) => {
      thread.messages = thread.messages.map(parseMessageFromAPI)
      res.data.threads[thread.composedid] = thread
      return true
    })

    return res.data
  } else {
    API.controlStatusFnct(res, `Unexpected status code for GET /messages?limit=1 : ${res.status}`)
  }
}

export const getThreadById = async (id) => {
  const res = await API.get(`thread/${id}`)

  if (res.status === 200) {
    if (!res.data && !res.data.thread) {
      return undefined
    }
    res.data.thread.messages = res.data.thread.messages.map(parseMessageFromAPI)

    return res.data.thread
  } else {
    API.controlStatusFnct(res, `Unexpected status code for GET /messages?limit=1 : ${res.status}`)
  }
}

export const getLastThreadsByFilter = async ({ type, value }, filterMode, page) => {
  value = value?.replace('&', '%26')
  const res = await API.get(`threads/search?filter=${type}&value=${value}&page=${page}&mode=${filterMode}`)
  if (res.status === 200) {
    if (!res.data) {
      return []
    }
    Object.values(res.data?.results)?.map((thread) => {
      thread.messages = thread.messages.map(parseMessageFromAPI)
      res.data.results[thread.composedid] = thread
      return true
    })

    res.data.threads = res.data.results

    return res.data
  } else {
    API.controlStatusFnct(res, `Unexpected status code for GET /messages/search?filter=${type}&value=${value}: ${res.status}`)
  }
}

export const setThreadDeletedValue = async (threadId, value) => {
  const res = await API.put(`threads/${threadId}`, {
    deleted: value,
  })
  if (res.status === 200) {
    return res.data
  } else {
    API.controlStatusFnct(res, `Unexpected status code for GET /messages?limit=1 : ${res.status}`)
  }
}

export const setThreadPinnedValue = async (threadId, value) => {
  const res = await API.put(`threads/${threadId}`, {
    pinned: value,
  })
  if (res.status === 200) {
    return res.data
  } else {
    API.controlStatusFnct(res, `Unexpected status code for GET /messages?limit=1 : ${res.status}`)
  }
}

export const getSubthreadsForThread = async (threadId) => {
  const res = await API.get(`threads/subthreads/${threadId}`)
  if (res.status === 200) {
    if (!res.data) {
      return []
    }
    Object.values(res.data?.threads)?.map((thread) => {
      thread.messages = thread.messages.map(parseMessageFromAPI)
      res.data.threads[thread.composedid] = thread
      return true
    })

    return res.data
  } else {
    API.controlStatusFnct(res, `Unexpected: ${res.status}`)
  }
}
